import { z } from 'zod';

export type CustomerAppPaymentMethods = z.infer<typeof CustomerAppPaymentMethods>;

export const CustomerAppPaymentMethods = z.object({
    /** The source where the payment method comes from. In most cases it will the the app. */
    source: z.string().nullish(),
    /** Specifies whether payment is enabled or not. */
    isEnabled: z.boolean(),
});
